import { outdentBlocks, outdentList } from "./outdent.helper";

export const MAX_INDENT_LEVEL = 14;
export const INDENT_SIZE = 40;

export class OutdentCommand {
  constructor(editor) {
    this.editor = editor;
  }

  execute() {
    const selection = this.editor.selection;
    const selectedBlocks = selection.getSelectedBlocks();

    if (!selectedBlocks.length) return;

    const savedSelection = this.saveSelection()
    const blockNodes = [];
    const liNodes = [];

    selectedBlocks.forEach((b) => {
      if (b.tagName.toLowerCase() === "li") {
        liNodes.push(b);
      } else {
        blockNodes.push(b);
      }
    });

    const affectedNodes = [];

    // Outdent blocks
    if (blockNodes.length > 0) {
      outdentBlocks({ blocks: blockNodes });
      affectedNodes.push(...blockNodes);
    }

    // Outdent list items
    if (liNodes.length > 0) {
      outdentList({ blocks: liNodes });
      affectedNodes.push(...liNodes);
    }

    // Rebuild selection AFTER DOM mutate
    this.restoreSelection(savedSelection);
  }
  saveSelection() {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return null;

    const range = sel.getRangeAt(0);

    return {
      startContainer: range.startContainer,
      startOffset: range.startOffset,
      endContainer: range.endContainer,
      endOffset: range.endOffset,
    };
  }

  restoreSelection(saved) {
    if (!saved) return;

    const sel = window.getSelection();
    if (!sel) return;

    try {
      const range = document.createRange();

      range.setStart(saved.startContainer, saved.startOffset);
      range.setEnd(saved.endContainer, saved.endOffset);

      sel.removeAllRanges();
      sel.addRange(range);
    } catch (e) {
      console.warn("Restore failed → fallback");
    }
  }
}